<script setup lang="ts">
import { computed } from 'vue';
import Iframe from '../../General/Iframe.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import { useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';

const session = useSessionStore()
const customUrl = computed<string | null>(() => session.classContent?.[Session.custom]?.custom_section_desc || null)
</script>

<template>
    <Fullscreen v-if="customUrl" class="p-3 h-full">
        <Iframe :src="customUrl" orientation="full" />
    </Fullscreen>
</template>